export default {
  name: 'auth',

  stopCallingRefreshAuto (idInterval) {
    clearInterval(idInterval)
  }

}



// WEBPACK FOOTER //
// ./src/helpers/eventManager.js